import React from 'react';
import classNames from 'classnames';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Button from 'b2b-ui-components-lib/lib/components/button';
import SupportIcon from '../../../../../../../src/assests/svg/icon_support.svg';
import SupportIconDisabled from '../../../../../../../src/assests/svg/need_assist_black.svg';
import './PlanConfigration.scss';
import { getLeadStatus, getOldLineItemDetail } from 'home/view/upgrade-order/utils';
import { LEAD_STATUS } from 'home/view/upgrade-order/constants';
import { numberWithCommas } from 'common/utils/app.utils';
import { isShiftingJourney } from 'common/constants/app.constants';

const PlanConfigration = (props) => {
  const {
    selectedContractPeriod,
    handleContractPeriodChange,
    CONTRACT_PERIOD_LIST,
    isDisabled,
    arc,
    otc,
    totalCost,
    setShowNeedAssistPopup,
    loading = false,
    checkErrors = () => {},
    onSubmitClick = () => {},
    onCancelClick = () => {},
    isSubmitDisabled = () => {},
    isCancelDisabled = () => {},
    leadData = {}
  } = props;

  const leadStatus = getLeadStatus(leadData);

  const existingARC =
    getOldLineItemDetail(leadData) &&
    getOldLineItemDetail(leadData).price &&
    getOldLineItemDetail(leadData).price.rental &&
    numberWithCommas(getOldLineItemDetail(leadData).price.rental);

  const showFooter = () => {
    return (
      leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED ||
      leadStatus === LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION ||
      leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT ||
      leadStatus === LEAD_STATUS.PRICING_DOA_APPROVED ||
      leadStatus === LEAD_STATUS.PRICING_DOA_REJECTED ||
      leadStatus === LEAD_STATUS.LEAD_SUBMITTED
    );
  };

  const titleGroup = (
    <div className="head_title">
      <h4>Plan & Configuration</h4>
      <h5>All fields are mandatory unless marked optional.</h5>
    </div>
  );
  return (
    <div className="plan_configration_controller">
      <div className="plan_config_details">
        <Select
          placeholder=""
          label="Contract Period"
          value={selectedContractPeriod}
          onChange={handleContractPeriodChange}
          options={CONTRACT_PERIOD_LIST}
          required
          touched
          disabled={isDisabled()}
        />
        <ul className="charge_list">
          {isShiftingJourney() && (
            <li className="old_arc">
              <div className="charge_name">Old Annual Recurring Charge (per year):</div>
              <div className="charge_value">₹{existingARC}</div>
            </li>
          )}
          <li>
            <div className="charge_name">{isShiftingJourney() ? `New Annual Recurring Charge (per year):` : `Annual Recurring Charge (Updated)`}</div>
            <div className="charge_value">₹{arc}</div>
          </li>
          <li>
            <div className="charge_name">{isShiftingJourney() ? `One Time Charge (Shifting Charges)` : `One Time Charge (Upgrade Charges)`}</div>
            <div className="charge_value">₹{otc}</div>
          </li>
          <li className="total_inclusion">
            <div className="charge_name">
              <strong>Total Contract Value</strong>
              <small>(Excluding GST rates as applicable)</small>
            </div>
            <div className="charge_value">₹{totalCost}</div>
          </li>
        </ul>
        <div
          className={classNames({
            help_support: true,
            disabled: isDisabled()
          })}
        >
          <a role="button" className={isDisabled() ? 'disabled' : ''} onClick={() => setShowNeedAssistPopup(true)}>
            <img src={isDisabled() ? SupportIconDisabled : SupportIcon} alt="Help" /> Request Pricing Assistance
          </a>
        </div>
      </div>
      {/* {showFooter() && (
        <div className="action_button">
          <Button variant="outlinebtn" displayName="Cancel" onClick={onCancelClick} disabled={isCancelDisabled()}></Button>
          <Button displayName="Next" disabled={loading || isSubmitDisabled()} onClick={onSubmitClick}>
            {loading && <span className="loading_icon"></span>}
          </Button>
        </div>
      )} */}
    </div>
  );
};

export default PlanConfigration;
